import { clientCallAPI } from '~/services/clientCallAPI';
import { fetchJobIdBySlug } from '~/services/job';
import FormRecruitment from './__components/form-recruitment';
import RecruitmentBenefits from './__components/recruitment-benefits';
import RecruitmentHighlights from './__components/recruitment-highlights';
import { Route } from './+types/cong-tac-vien';
import { data } from 'react-router';
import { Img } from 'openimg/react';
import { cn } from '@repo/ui/lib/utils';
import SectionChild from '~/components/SectionChild';
import { Button } from '@repo/ui/components/button';
import { useRef } from "react";
import { ArrowRight } from '@repo/ui/components/icon';
export async function action({ request }: Route.ActionArgs) {
  const ct = request.headers.get("content-type") || "";
  let payload: any;
  try {
    if (ct.includes("application/json")) {
      payload = await request.json();
    } else {
      const formData = await request.formData();
      payload = Object.fromEntries(formData.entries());
    }
    if (payload?.formType === "recruitment") {
      const { name, phone, email, note } = payload;
      const jobId = await fetchJobIdBySlug("cong-tac-vien");
      await clientCallAPI("/api/hiring-application", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          phone,
          email,
          jobId,
          note: note || "",
        }),
      });
      return data({ ok: true });
    }
    return data({ ok: false, message: "Unknown formType" }, { status: 400 });
  } catch (error) {
    console.log(error);
    return data({ ok: false }, { status: 400 });
  }
}


function FormRecruitmentPage() {
    const ref = useRef<any>(null);

  const handleScroll=()=>{
       ref.current?.scrollIntoView({
         behavior: "smooth",
       });
  }
  return (
    <div className="relative">
      <div
        className={cn("w-full h-[375px] md:h-[522px] relative overflow-hidden")}
      >
        <Img
          src="/image/tuyen-dung/bg-3.jpg"
          width={1440}
          height={522}
          className="absolute top-0 left-0 object-cover w-full h-full bg-right"
          fit="cover"
          params={{ quality: "90" }}
          isAboveFold
        />
        <div className="absolute z-10 w-full top-2/4 -translate-y-2/4">
          <SectionChild>
            <div className="space-y-4 text-white max-w-[566px] leading-[28px]">
              <div className="text-[18px]">
                Trở thành Cộng tác viên Bất động sản cùng KLAND
              </div>
              <div className="font-bold text-[40px] font-helve leading-[44px]">
                Bắt đầu hành trình tự do tài chính – không giới hạn thu nhập
              </div>
              <div className="text-[18px]">
                Bạn không cần kinh nghiệm – chỉ cần tinh thần học hỏi. Hệ sinh
                thái KLAND giúp bạn có dữ liệu, công cụ & hướng dẫn từ A–Z
              </div>
              <Button
                className="bg-white text-primary hover:bg-white"
                size={"lg"}
                onClick={handleScroll}
              >
                Đăng ký ngay
                <ArrowRight />
              </Button>
            </div>
          </SectionChild>
        </div>
      </div>

      <RecruitmentBenefits />
      <RecruitmentHighlights />
      <div ref={ref}>
        <FormRecruitment />
      </div>
      <SectionChild className=" pt-[80px] pb-[100px]">
        <div className="relative h-[332px] rounded-4xl overflow-hidden">
          <Img
            src="/image/tuyen-dung/bg-4.jpg"
            width={1440}
            height={522}
            className="absolute top-0 left-0 object-cover w-full h-full bg-right"
            fit="cover"
            params={{ quality: "90" }}
          />
          <div className="absolute space-y-10 top-8 left-8">
            <h3 className="text-3xl text-white leading-[44px] max-w-[504px]">
              Gia nhập mạng lưới hơn 5.000 cộng tác viên KLAND và bắt đầu hành
              trình tài chính tự do của bạn
            </h3>

            <Button variant={"secondary"} size={"lg"} onClick={handleScroll}>
              Đăng ký ngay hôm nay
            </Button>
          </div>
        </div>
      </SectionChild>
    </div>
  );
}

export default FormRecruitmentPage;
